<template>
  <div class="creation-dates-both-selection">
    <section>
      <!-- if dates not set, display buttons -->
      <ExtraBtnSquare
        :active="isSingle"
        icon="fad fa-calendar-day"
        :label="$t('ETAB.PAGES.DEMANDS.CREATION.@DATES_SELECTION_SINGLE')"
        @click="$emit('selectSingle')"
      />
      <ExtraBtnSquare
        :active="isMultiple"
        icon="fad fa-calendar-range"
        :label="$t('ETAB.PAGES.DEMANDS.CREATION.@DATES_SELECTION_MULTIPLE')"
        @click="$emit('selectMultiple')"
      />
    </section>
    <template v-if="isMultiple">
      <!-- if dates are already set, display them -->
      <a @click="$emit('selectMultiple')">
        <IconBoxWrapper icon="icon-f-calendar">
          <QInput
            class="creation-dates-selected"
            :label="$t('ETAB.PAGES.DEMANDS.CREATION.@DATE_START')"
            :model-value="startDateFormatted"
            borderless
            readonly
          />
          <QInput
            class="creation-dates-selected"
            :label="$t('ETAB.PAGES.DEMANDS.CREATION.@DATE_END')"
            :model-value="endDateFormatted"
            borderless
            readonly
          />
        </IconBoxWrapper>
      </a>
    </template>
    <template v-if="isSingle">
      <!-- if date is already set, display it -->
      <a @click="$emit('selectSingle')">
        <IconBoxWrapper icon="icon-f-calendar">
          <QInput
            class="creation-date-selected"
            :label="$t('ETAB.PAGES.DEMANDS.CREATION.@DATE_SELECTED')"
            :model-value="singleDateFormatted"
            borderless
            readonly
          />
        </IconBoxWrapper>
      </a>
    </template>
  </div>
</template>

<script>
  import { DatesHelpers } from "@core/helpers";

  export default {
    props: {
      date: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ["selectSingle", "selectMultiple"],
    computed: {
      startDateFormatted() {
        return DatesHelpers.getDayjs(this.date.start).format("L");
      },
      endDateFormatted() {
        return DatesHelpers.getDayjs(this.date.end).format("L");
      },
      singleDateFormatted() {
        return this.startDateFormatted;
      },
      isMultiple() {
        return this.date && this.date.start && this.date.end;
      },
      isSingle() {
        return this.date && this.date.start && !this.date.end;
      },
    },
  };
</script>

<style lang="scss">
  .creation-dates-both-selection {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    > section {
      margin-bottom: 50px;

      > button:first-of-type {
        margin-right: 10px;
      }
    }

    .creation-dates-selected,
    .creation-date-selected {
      padding: 0px 15px;
    }

    a {
      padding: 0px 10px;
      max-width: 315px; // same width as two buttons
    }
  }
</style>
